import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "./actions";
import Create from "./Create";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "../Common/modal";
import ConfirmationModal from "../Common/confirmationModal";
import { semanticColors, greyScaleColors } from "../Globals/styles";
import Radium from "radium";
import auth from "../Login/authService";
import { httpGet } from "../Util/http";
import { downloadBlob } from "../Util/downloadBlob";
import DatePickerRange from "../Common/datepickerRange";

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: auth.getProfile().role,
      hide: true,
      document: null,
      infoBox: true,
      infoBoxData: undefined,
      opens: {},
      dates: undefined,
      resetter: 0,
    };
  }

  componentWillMount = () => {
    this.props.dispatch(actions.searchProduct("", 0, 50));
    this.setState({
      query: "",
      take: 50,
    });
  };

  submitEdited = (editedproduct, index) => {
    //only submit if something changed
    const { products, dispatch } = this.props;
    var orig = products[index];
    if (
      orig.productId !== editedproduct.productId ||
      orig.name !== editedproduct.name ||
      orig.price !== editedproduct.price ||
      orig.unit !== editedproduct.unit ||
      orig.type !== editedproduct.type ||
      orig.technicalDataSheet !== editedproduct.technicalDataSheet ||
      orig.dataSheet !== editedproduct.dataSheet ||
      orig.chemDataSheet !== editedproduct.chemDataSheet
    ) {
      dispatch(actions.editProduct(editedproduct, index));
    } else {
      dispatch(actions.setState("inEditMode", { active: false }));
    }
  };

  onScroll = (evt) => {
    const { products, dispatch } = this.props;
    if (evt.top === 1) {
      dispatch(
        actions.searchProductPaginate(
          this.state.query,
          products.length,
          this.state.take
        )
      );
    }
  };

  onSearch = (query) => {
    const { dispatch } = this.props;
    this.setState({
      query: query,
    });
    if (this.props.inEditMode) {
      dispatch(actions.setState("inEditMode", { active: false }));
    }
    dispatch(actions.searchProduct(query, 0, this.state.take));
  };

  openPdf = (pdfUrl, base64) => {
    if (base64) {
      this.setState({
        hide: false,
        document: { base64: "data:application/pdf;base64, " + pdfUrl },
      });
    } else {
      this.setState({
        hide: false,
        document: { url: pdfUrl },
      });
    }
  };

  emptyRow = () => {
    return (
      <div style={{ display: "table-row" }}>
        <div style={{ ...styles.cell }}>{" - "}</div>
        <div style={{ ...styles.cell }}>{" - "}</div>
        <div style={{ ...styles.cell }}>{" - "}</div>
        <div style={{ ...styles.cell }}>{" - "}</div>
        <div style={{ ...styles.cell }}>{" - "}</div>
      </div>
    );
  };

  render() {
    const {
      dispatch,
      products,
      inEditMode,
      confirmDeletion,
      inCreateMode,
      isFetching,
    } = this.props;

    return (
      <div style={styles.container}>
        <Modal
          key={Math.random()}
          hide={this.state.hide}
          onClose={() => {
            this.setState({ hide: !this.state.hide });
          }}
        >
          {this.state.document ? (
            this.state.document.base64 ? (
              <iframe
                title="dpf"
                scrolling="no"
                width="100%"
                height="95%"
                src={this.state.document.base64}
              ></iframe>
            ) : (
              <iframe
                title="dpdf"
                scrolling="no"
                width="100%"
                height="95%"
                src={
                  "https://docs.google.com/viewer?url=" +
                  this.state.document.url +
                  "&embedded=true"
                }
              ></iframe>
            )
          ) : null}
        </Modal>
        <div style={styles.topContainer}>
          {this.state.role !== "Formand" ? (
            <button
              className="btn btn-primary"
              style={styles.createButton}
              onClick={() =>
                dispatch(actions.setState("inCreateMode", { active: true }))
              }
              disabled={inCreateMode.active}
            >
              Opret ny
            </button>
          ) : null}

          <input
            onChange={(evt) => this.onSearch(evt.target.value)}
            style={styles.searchField}
            placeholder="Søg"
          />
          {isFetching ? (
            <i className="fa fa-spinner fa-spin" style={styles.fetchingIcon} />
          ) : null}
        </div>
        {confirmDeletion.active ? (
          <ConfirmationModal
            closeModal={() =>
              dispatch(actions.setState("confirmDeletion", { active: false }))
            }
            onYesMethod={() =>
              dispatch(
                actions.deleteProduct(
                  confirmDeletion.productId,
                  confirmDeletion.index
                )
              )
            }
            headerText="product"
            text={
              <div>
                Du er ved at slette "
                <b>{products[confirmDeletion.index].name}</b>".
                <br />
                Vil du fortsætte?
              </div>
            }
          />
        ) : null}

        <div style={styles.table}>
          <div style={[styles.thead]}>
            <div className="row" style={[styles.tr, styles.headerRow]}>
              <div
                className={
                  this.state.role === "Formand" ? "col-xs-6" : "col-xs-5"
                }
                style={[styles.th, styles.firstTd]}
              >
                Beskrivelse
              </div>
              <div className="col-xs-1" style={styles.th}>
                Enhed
              </div>
              <div
                className={
                  this.state.role === "Formand" ? "col-xs-1" : "col-xs-1"
                }
                style={styles.th}
              >
                Type
              </div>
              {this.state.role === "Formand" ? null : (
                <div className="col-xs-1" style={styles.th}>
                  Nettopris
                </div>
              )}
              <div
                className="col-xs-1"
                style={[styles.th, { textAlign: "center" }]}
              >
                Sikkerheds Datablad
              </div>
              <div
                className="col-xs-1"
                style={[styles.th, { textAlign: "center" }]}
              >
                Teknisk Datablad
              </div>
              <div
                className="col-xs-1"
                style={[styles.th, { textAlign: "center" }]}
              >
                Kemisk risikovurdering
              </div>
              {this.state.role === "Formand" ? null : (
                <div
                  className="col-xs-1"
                  style={[styles.th, styles.lastInTr]}
                ></div>
              )}
            </div>
          </div>
          <Modal
            key={"123"}
            hide={this.state.infoBox}
            onClose={() => {
              this.setState({
                infoBox: !this.state.infoBox,
                openAll: false,
                opens: {},
              });
            }}
          >
            {!this.state.infoBoxData ? null : (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "white",
                  overflow: "scroll",
                }}
              >
                <div
                  className="row"
                  style={{
                    borderBottom: `1px solid ${semanticColors.mainBackground}`,
                  }}
                >
                  <div
                    className="col-xs-6"
                    style={{ textAlign: "left", fontSize: 22 }}
                  >
                    <div style={{ padding: 6 }}>
                      {this.state.infoBoxData.materiel.name}
                    </div>
                  </div>
                  <div className="col-xs-2">
                    Pris: {this.state.infoBoxData.materiel.price}
                  </div>
                  <div className="col-xs-2">
                    Enhed: {this.state.infoBoxData.materiel.unit}
                  </div>
                  <div className="col-xs-2">
                    Type: {this.state.infoBoxData.materiel.type}
                  </div>
                </div>
                <div className="row" style={{ paddingTop: 12 }}>
                  <DatePickerRange
                    key={this.state.resetter}
                    dates={this.state.dates}
                    onChange={async (start, end) => {
                      var _url =
                        process.env.REACT_APP_webApiEndPoint +
                        `api/materiel/stats/range/${
                          this.state.infoBoxData.materiel.productId
                        }?from=${start.getTime() / 1000}&to=${
                          end.getTime() / 1000
                        }`;
                      await httpGet(_url)
                        .then((response) => {
                          return response.json();
                        })
                        .then((json) => {
                          json.materiel = this.state.infoBoxData.materiel;

                          const {
                            workplaces,
                            project: projects,
                            departments,
                          } = json;

                          const grouper = {};
                          const counter = { dagrapportCount: 0, amount: 0 };
                          const allIds = {};
                          let allSubs = {};
                          json.mats.forEach((mw) => {
                            counter.dagrapportCount += mw.dagrapportCount;
                            counter.amount += mw.amount;

                            var workplace = {
                              ...workplaces[mw.workplaceId],
                              materiels: {},
                            };
                            var project = {
                              ...projects[workplace.projectId],
                              workplaces: {},
                            };
                            var department = {
                              ...departments[workplace.departmentId],
                              projects: {},
                            };
                            if (!grouper[workplace.departmentId]) {
                              grouper[workplace.departmentId] = department;
                              grouper[workplace.departmentId].amount = 0;
                              grouper[
                                workplace.departmentId
                              ].dagrapportCount = 0;
                              grouper[workplace.departmentId].snCount = 0;
                              allIds[workplace.departmentId] = true;
                            }
                            if (
                              !grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ]
                            ) {
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ] = project;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].amount = 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].dagrapportCount = 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].snCount = 0;
                              allIds[workplace.projectId] = true;
                            }
                            if (
                              !grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId]
                            ) {
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId] = workplace;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].amount = 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].dagrapportCount = 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].snCount = 0;
                              allIds[mw.workplaceId] = true;
                            }

                            grouper[workplace.departmentId].amount += mw.amount;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].amount += mw.amount;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].workplaces[mw.workplaceId].amount += mw.amount;
                            grouper[workplace.departmentId].dagrapportCount +=
                              mw.dagrapportCount;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].dagrapportCount += mw.dagrapportCount;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].workplaces[mw.workplaceId].dagrapportCount +=
                              mw.dagrapportCount;

                            grouper[workplace.departmentId].snCount += mw.subs
                              ? mw.subs.length
                              : 0;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].snCount += mw.subs ? mw.subs.length : 0;
                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].workplaces[mw.workplaceId].snCount += mw.subs
                              ? mw.subs.length
                              : 0;

                            grouper[workplace.departmentId].projects[
                              workplace.projectId
                            ].workplaces[mw.workplaceId].materiels[
                              mw.materielId
                            ] = mw;
                            if (mw.subs && mw.subs.length > 0) {
                              mw.subs.forEach((sub) => {
                                if (allSubs[sub]) {
                                  allSubs[sub]++;
                                } else {
                                  allSubs[sub] = 1;
                                }
                              });
                            }
                          });

                          let depsCounter = 0;
                          let projectsCounter = 0;
                          let workplacesCounter = 0;
                          let snCounter = 0;
                          Object.values(grouper).forEach((depart) => {
                            depart.projectCount = Object.values(
                              depart.projects
                            ).length;
                            depart.workplacesCount = 0;
                            depsCounter += 1;
                            snCounter += depart.snCount;
                            projectsCounter += depart.projectCount;
                            Object.values(depart.projects).forEach((proj) => {
                              let workplaceCount = Object.values(
                                proj.workplaces
                              ).length;
                              proj.workplacesCount = workplaceCount;
                              depart.workplacesCount += workplaceCount;
                              workplacesCounter += workplaceCount;
                            });
                          });
                          console.log(allSubs);
                          this.setState({
                            infoBox: false,
                            infoBoxData: json,
                            grouper,
                            counter,
                            depsCounter,
                            projectsCounter,
                            workplacesCounter,
                            snCounter,
                            allIds,
                            allSubs,
                            dates: {
                              start: start.getTime(),
                              end: end.getTime(),
                            },
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                          alert("kunne ikke hente det");
                        });
                    }}
                  ></DatePickerRange>
                  <div style={{ position: "relative" }}>
                    <div
                      style={{
                        position: "absolute",
                        bottom: 10,
                        right: 60,
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        var _url =
                          process.env.REACT_APP_webApiEndPoint +
                          `api/materiel/stats/${this.state.infoBoxData.materiel.productId}`;
                        await httpGet(_url)
                          .then((response) => {
                            return response.json();
                          })
                          .then((json) => {
                            json.materiel = this.state.infoBoxData.materiel;

                            const {
                              workplaces,
                              project: projects,
                              departments,
                            } = json;

                            const grouper = {};
                            const counter = { dagrapportCount: 0, amount: 0 };
                            const allIds = {};
                            let allSubs = {};
                            json.mats.forEach((mw) => {
                              counter.dagrapportCount += mw.dagrapportCount;
                              counter.amount += mw.amount;

                              var workplace = {
                                ...workplaces[mw.workplaceId],
                                materiels: {},
                              };
                              var project = {
                                ...projects[workplace.projectId],
                                workplaces: {},
                              };
                              var department = {
                                ...departments[workplace.departmentId],
                                projects: {},
                              };
                              if (!grouper[workplace.departmentId]) {
                                grouper[workplace.departmentId] = department;
                                grouper[workplace.departmentId].amount = 0;
                                grouper[
                                  workplace.departmentId
                                ].dagrapportCount = 0;
                                grouper[workplace.departmentId].snCount = 0;
                                allIds[workplace.departmentId] = true;
                              }
                              if (
                                !grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ]
                              ) {
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ] = project;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].amount = 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].dagrapportCount = 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].snCount = 0;
                                allIds[workplace.projectId] = true;
                              }
                              if (
                                !grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId]
                              ) {
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId] = workplace;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].amount = 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[
                                  mw.workplaceId
                                ].dagrapportCount = 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].snCount = 0;
                                allIds[mw.workplaceId] = true;
                              }

                              grouper[workplace.departmentId].amount +=
                                mw.amount;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].amount += mw.amount;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].amount += mw.amount;
                              grouper[workplace.departmentId].dagrapportCount +=
                                mw.dagrapportCount;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].dagrapportCount += mw.dagrapportCount;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].dagrapportCount +=
                                mw.dagrapportCount;

                              grouper[workplace.departmentId].snCount += mw.subs
                                ? mw.subs.length
                                : 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].snCount += mw.subs ? mw.subs.length : 0;
                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].snCount += mw.subs
                                ? mw.subs.length
                                : 0;

                              grouper[workplace.departmentId].projects[
                                workplace.projectId
                              ].workplaces[mw.workplaceId].materiels[
                                mw.materielId
                              ] = mw;
                              if (mw.subs && mw.subs.length > 0) {
                                mw.subs.forEach((sub) => {
                                  if (allSubs[sub]) {
                                    allSubs[sub]++;
                                  } else {
                                    allSubs[sub] = 1;
                                  }
                                });
                              }
                            });

                            let depsCounter = 0;
                            let projectsCounter = 0;
                            let workplacesCounter = 0;
                            let snCounter = 0;
                            Object.values(grouper).forEach((depart) => {
                              depart.projectCount = Object.values(
                                depart.projects
                              ).length;
                              depart.workplacesCount = 0;
                              depsCounter += 1;
                              snCounter += depart.snCount;
                              projectsCounter += depart.projectCount;
                              Object.values(depart.projects).forEach((proj) => {
                                let workplaceCount = Object.values(
                                  proj.workplaces
                                ).length;
                                proj.workplacesCount = workplaceCount;
                                depart.workplacesCount += workplaceCount;
                                workplacesCounter += workplaceCount;
                              });
                            });
                            console.log(allSubs);
                            this.setState({
                              infoBox: false,
                              infoBoxData: json,
                              grouper,
                              counter,
                              depsCounter,
                              projectsCounter,
                              workplacesCounter,
                              snCounter,
                              allIds,
                              allSubs,
                              dates: undefined,
                              resetter: Math.random(),
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                            alert("kunne ikke hente det");
                          });
                      }}
                    >
                      NULSTIL
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    onClick={() => {
                      this.setState({
                        openAll: !this.state.openAll,
                        opens: !this.state.openAll ? this.state.allIds : {},
                      });
                    }}
                    className="col-xs-12"
                    style={{
                      textAlign: "right",
                      fontSize: 10,
                      padding: 6,
                      paddingRight: 20,
                      cursor: "pointer",
                      fontWeight: "bold",
                      marginRight: 20,
                    }}
                  >
                    {!this.state.openAll ? "FOLD UD" : "FOLD SAMMEN"}
                  </div>
                </div>
                <section
                  style={{
                    display: "table",
                    tableLayout: "auto",
                    width: "100%",
                  }}
                >
                  <header style={{ display: "table-row" }}>
                    <div
                      style={{
                        ...styles.cell,
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      AFDELING
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      SAG
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      ARBEJDSSTED
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      FORBRUG
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      DAG
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        borderTop: ".1px solid lightgray",
                      }}
                    >
                      {this.state.infoBoxData.materiel.type === "Materiale"
                        ? "BA"
                        : "SN"}
                    </div>
                  </header>
                  {Object.values(this.state.grouper).map((department) => {
                    const depRender = (
                      <div
                        key={department.id}
                        style={{ borderSpacing: 20, display: "table-row" }}
                        onClick={() => {
                          let open = true;
                          if (
                            this.state.opens[department.aggregateId] !==
                            undefined
                          ) {
                            open = !this.state.opens[department.aggregateId];
                          }
                          const opens = {
                            ...this.state.opens,
                            [department.aggregateId]: open,
                          };
                          this.setState({
                            opens,
                          });
                        }}
                      >
                        <div
                          style={{
                            ...styles.cell,
                            cursor: "pointer",
                            fontWeight: "bold",
                          }}
                        >
                          {department.name}
                          <i
                            style={{ paddingLeft: 12 }}
                            className={
                              this.state.opens[department.aggregateId]
                                ? "fa fa-caret-up"
                                : "fa fa-caret-down"
                            }
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div
                          style={{
                            ...styles.cell,
                            color: "lightgray",
                            textAlign: "center",
                          }}
                        >
                          {department.projectCount}
                        </div>
                        <div
                          style={{
                            ...styles.cell,
                            color: "lightgray",
                            textAlign: "center",
                          }}
                        >
                          {department.workplacesCount}
                        </div>
                        <div
                          style={{
                            ...styles.cell,
                            fontWeight: "normal",
                            textAlign: "center",
                          }}
                        >
                          {department.amount.toFixed(2)}
                        </div>
                        <div
                          style={{
                            ...styles.cell,
                            fontWeight: "normal",
                            textAlign: "center",
                          }}
                        >
                          {department.dagrapportCount}
                        </div>
                        <div
                          style={{
                            ...styles.cell,
                            color: "lightgray",
                            textAlign: "center",
                          }}
                        >
                          {department.snCount}
                        </div>
                      </div>
                    );
                    const projectRender = Object.values(
                      department.projects
                    ).map((project) => {
                      const projectRenderNested = (
                        <div
                          key={project.id}
                          style={{ display: "table-row" }}
                          onClick={() => {
                            let open = true;
                            if (
                              this.state.opens[project.aggregateId] !==
                              undefined
                            ) {
                              open = !this.state.opens[project.aggregateId];
                            }
                            const opens = {
                              ...this.state.opens,
                              [project.aggregateId]: open,
                            };
                            this.setState({
                              opens,
                            });
                          }}
                        >
                          <div style={{ ...styles.cell, color: "lightgray" }}>
                            {department.name}
                          </div>
                          <div style={{ ...styles.cell, cursor: "pointer" }}>
                            {project.number + " - " + project.name}
                            <i
                              style={{ paddingLeft: 12 }}
                              className={
                                this.state.opens[project.aggregateId]
                                  ? "fa fa-caret-up"
                                  : "fa fa-caret-down"
                              }
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div
                            style={{
                              ...styles.cell,
                              color: "lightgray",
                              textAlign: "center",
                            }}
                          >
                            {project.workplacesCount}
                          </div>
                          <div
                            style={{
                              ...styles.cell,
                              textAlign: "center",
                              color: this.state.opens[project.aggregateId]
                                ? "lightgray"
                                : undefined,
                            }}
                          >
                            {project.amount.toFixed(2)}
                          </div>
                          <div
                            style={{
                              ...styles.cell,
                              textAlign: "center",
                              color: this.state.opens[project.aggregateId]
                                ? "lightgray"
                                : undefined,
                            }}
                          >
                            {project.dagrapportCount}
                          </div>
                          <div
                            style={{
                              ...styles.cell,
                              color: "lightgray",
                              textAlign: "center",
                            }}
                          >
                            {project.snCount}
                          </div>
                        </div>
                      );

                      const workplacesRender = Object.values(
                        project.workplaces
                      ).map((workplace) => {
                        const worplacere = (
                          <div
                            key={workplace.id}
                            style={{ display: "table-row", cursor: "pointer" }}
                            onClick={() => {
                              let open = true;
                              if (
                                this.state.opens[workplace.aggregateId] !==
                                undefined
                              ) {
                                open = !this.state.opens[workplace.aggregateId];
                              }
                              const opens = {
                                ...this.state.opens,
                                [workplace.aggregateId]: open,
                              };
                              this.setState({
                                opens,
                              });
                            }}
                          >
                            <div style={{ ...styles.cell, color: "lightgray" }}>
                              {department.name}
                            </div>
                            <div style={{ ...styles.cell, color: "lightgray" }}>
                              {project.number + " - " + project.name}
                            </div>
                            <div style={{ ...styles.cell }}>
                              {workplace.name}
                              {workplace.snCount == 0 ? null : (
                                <i
                                  style={{ paddingLeft: 12 }}
                                  className={
                                    this.state.opens[workplace.aggregateId]
                                      ? "fa fa-caret-up"
                                      : "fa fa-caret-down"
                                  }
                                  aria-hidden="true"
                                ></i>
                              )}
                            </div>
                            <div
                              style={{ ...styles.cell, textAlign: "center" }}
                            >
                              {workplace.amount.toFixed(2)}
                            </div>
                            <div
                              style={{ ...styles.cell, textAlign: "center" }}
                            >
                              {workplace.dagrapportCount}
                            </div>
                            <div
                              style={{
                                ...styles.cell,
                                textAlign: "center",
                                color:
                                  workplace.snCount == 0
                                    ? "lightgray"
                                    : undefined,
                              }}
                            >
                              {workplace.snCount}
                            </div>
                          </div>
                        );
                        const subs =
                          Object.values(workplace.materiels)[0].subs &&
                          Object.values(workplace.materiels)[0].subs.length > 0
                            ? Object.values(workplace.materiels)[0].subs.map(
                                (sub) => {
                                  return (
                                    <div
                                      key={sub}
                                      style={{ display: "table-row" }}
                                    >
                                      <div style={{ ...styles.cell }}>{}</div>
                                      <div style={{ ...styles.cell }}>{}</div>
                                      <div style={{ ...styles.cell }}>{}</div>
                                      <div style={{ ...styles.cell }}>{}</div>
                                      <div style={{ ...styles.cell }}>
                                        {this.state.infoBoxData.materiel
                                          .type === "Materiale"
                                          ? "Batch nummer"
                                          : "Serienummer"}
                                      </div>
                                      <div style={{ ...styles.cell }}>
                                        {sub}
                                      </div>
                                    </div>
                                  );
                                }
                              )
                            : null;
                        if (this.state.opens[workplace.aggregateId] === true) {
                          return [worplacere, subs];
                        }
                        return [worplacere];
                      });

                      if (this.state.opens[project.aggregateId] === true) {
                        return [projectRenderNested, workplacesRender];
                      }
                      return [projectRenderNested];
                    });
                    if (this.state.opens[department.aggregateId] === true) {
                      return [depRender, projectRender];
                    }
                    return [depRender];
                  })}
                  <div key={"total"} style={{ display: "table-row" }}>
                    <div
                      style={{
                        ...styles.cell,
                        color: "gray",
                        textAlign: "center",
                      }}
                    >
                      {this.state.depsCounter}
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        color: "gray",
                        textAlign: "center",
                      }}
                    >
                      {this.state.projectsCounter}
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        color: "gray",
                        textAlign: "center",
                      }}
                    >
                      {this.state.workplacesCounter}
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        color: "gray",
                        textAlign: "center",
                      }}
                    >
                      {this.state.counter.amount.toFixed(2)}
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        color: "gray",
                        textAlign: "center",
                      }}
                    >
                      {this.state.counter.dagrapportCount}
                    </div>
                    <div
                      style={{
                        ...styles.cell,
                        textAlign: "center",
                        color: this.state.snCounter == 0 ? "lightgray" : "gray",
                      }}
                    >
                      {this.state.snCounter}
                    </div>
                  </div>
                </section>
                <div style={{ position: "relative", paddingTop: 40 }}>
                  <div style={{ position: "absolute", bottom: 0, right: 12 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <div style={{ fontSize: 8 }}>
                        {this.state.infoBoxData.materiel.type === "Materiale"
                          ? "BA = BATCH NUMMER"
                          : "SN = SERIENUMMER"}
                      </div>
                      <div style={{ fontSize: 8 }}>
                        DAG = ANTAL DAGRAPPORTER MATERIEL ER REGISTRERET I
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.allSubs &&
                Object.keys(this.state.allSubs).length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      padding: 12,
                    }}
                  >
                    <h5>
                      Alle{" "}
                      {this.state.infoBoxData.materiel.type === "Materiale"
                        ? "Batch numre"
                        : "Serienumre"}
                    </h5>
                    {Object.keys(this.state.allSubs).map((subss, index) => (
                      <div key={index} style={{ display: "flex" }}>
                        {subss} - Brugt i {this.state.allSubs[subss]}{" "}
                        dagrapport(er)
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            )}
          </Modal>
          <Scrollbars
            style={{ height: "100%", width: "100%" }}
            onScrollFrame={this.onScroll}
          >
            {inCreateMode.active ? (
              <Create
                isOdd={true}
                isSubmitting={inCreateMode.isSubmitting}
                onClose={() =>
                  dispatch(actions.setState("inCreateMode", { active: false }))
                }
                onSubmit={(createproduct) =>
                  dispatch(actions.createProduct(createproduct))
                }
              />
            ) : null}
            {products.map((m, i) => {
              if (inEditMode.active && inEditMode.productId === m.productId) {
                m.dataSheet = m.dataSheetUrl;
                m.technicalDataSheet = m.technicalDataSheetUrl;
                m.chemDataSheet = m.chemDataSheetUrl;
                return (
                  <Create
                    key={m.productId}
                    defaultValue={m}
                    isOdd={i % 2 !== 0}
                    isSubmitting={inEditMode.isSubmitting}
                    onClose={() =>
                      dispatch(
                        actions.setState("inEditMode", { active: false })
                      )
                    }
                    onSubmit={(editedproduct) =>
                      this.submitEdited(editedproduct, i)
                    }
                  />
                );
              } else {
                return (
                  <div
                    className="row"
                    key={m.productId}
                    style={[styles.tr, i % 2 && styles.trOdd]}
                  >
                    <div
                      className={
                        this.state.role === "Formand" ? "col-xs-6" : "col-xs-5"
                      }
                      style={[styles.td, styles.firstTd]}
                    >
                      {m.name}
                      <div
                        onClick={async () => {
                          var _url =
                            process.env.REACT_APP_webApiEndPoint +
                            `api/materiel/stats/${m.productId}`;
                          await httpGet(_url)
                            .then((response) => {
                              return response.json();
                            })
                            .then((json) => {
                              json.materiel = m;

                              const {
                                workplaces,
                                project: projects,
                                departments,
                              } = json;

                              const grouper = {};
                              const counter = { dagrapportCount: 0, amount: 0 };
                              const allIds = {};
                              let allSubs = {};
                              json.mats.forEach((mw) => {
                                counter.dagrapportCount += mw.dagrapportCount;
                                counter.amount += mw.amount;

                                var workplace = {
                                  ...workplaces[mw.workplaceId],
                                  materiels: {},
                                };
                                var project = {
                                  ...projects[workplace.projectId],
                                  workplaces: {},
                                };
                                var department = {
                                  ...departments[workplace.departmentId],
                                  projects: {},
                                };
                                if (!grouper[workplace.departmentId]) {
                                  grouper[workplace.departmentId] = department;
                                  grouper[workplace.departmentId].amount = 0;
                                  grouper[
                                    workplace.departmentId
                                  ].dagrapportCount = 0;
                                  grouper[workplace.departmentId].snCount = 0;
                                  allIds[workplace.departmentId] = true;
                                }
                                if (
                                  !grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ]
                                ) {
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ] = project;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].amount = 0;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].dagrapportCount = 0;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].snCount = 0;
                                  allIds[workplace.projectId] = true;
                                }
                                if (
                                  !grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].workplaces[mw.workplaceId]
                                ) {
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].workplaces[mw.workplaceId] = workplace;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].workplaces[mw.workplaceId].amount = 0;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].workplaces[
                                    mw.workplaceId
                                  ].dagrapportCount = 0;
                                  grouper[workplace.departmentId].projects[
                                    workplace.projectId
                                  ].workplaces[mw.workplaceId].snCount = 0;
                                  allIds[mw.workplaceId] = true;
                                }

                                grouper[workplace.departmentId].amount +=
                                  mw.amount;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].amount += mw.amount;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].amount +=
                                  mw.amount;
                                grouper[
                                  workplace.departmentId
                                ].dagrapportCount += mw.dagrapportCount;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].dagrapportCount += mw.dagrapportCount;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].dagrapportCount +=
                                  mw.dagrapportCount;

                                grouper[workplace.departmentId].snCount +=
                                  mw.subs ? mw.subs.length : 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].snCount += mw.subs ? mw.subs.length : 0;
                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].snCount += mw.subs
                                  ? mw.subs.length
                                  : 0;

                                grouper[workplace.departmentId].projects[
                                  workplace.projectId
                                ].workplaces[mw.workplaceId].materiels[
                                  mw.materielId
                                ] = mw;
                                if (mw.subs && mw.subs.length > 0) {
                                  mw.subs.forEach((sub) => {
                                    if (allSubs[sub]) {
                                      allSubs[sub]++;
                                    } else {
                                      allSubs[sub] = 1;
                                    }
                                  });
                                }
                              });

                              let depsCounter = 0;
                              let projectsCounter = 0;
                              let workplacesCounter = 0;
                              let snCounter = 0;
                              Object.values(grouper).forEach((depart) => {
                                depart.projectCount = Object.values(
                                  depart.projects
                                ).length;
                                depart.workplacesCount = 0;
                                depsCounter += 1;
                                snCounter += depart.snCount;
                                projectsCounter += depart.projectCount;
                                Object.values(depart.projects).forEach(
                                  (proj) => {
                                    let workplaceCount = Object.values(
                                      proj.workplaces
                                    ).length;
                                    proj.workplacesCount = workplaceCount;
                                    depart.workplacesCount += workplaceCount;
                                    workplacesCounter += workplaceCount;
                                  }
                                );
                              });
                              console.log(allSubs);
                              this.setState({
                                infoBox: !this.state.infoBox,
                                infoBoxData: json,
                                grouper,
                                counter,
                                depsCounter,
                                projectsCounter,
                                workplacesCounter,
                                snCounter,
                                allIds,
                                allSubs,
                              });
                            })
                            .catch((err) => {
                              console.log(err);
                              alert("kunne ikke hente det");
                            });
                        }}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 12,
                          fontStyle: "italic",
                          cursor: "pointer",
                        }}
                      >
                        info
                      </div>
                    </div>
                    <div className="col-xs-1" style={styles.td}>
                      {m.unit}
                    </div>
                    <div className="col-xs-1" style={styles.td}>
                      {m.type}
                    </div>
                    {this.state.role === "Formand" ? null : (
                      <div className="col-xs-1" style={styles.td}>
                        {m.price}
                      </div>
                    )}
                    <div
                      className="col-xs-1"
                      style={[
                        styles.td,
                        { lineHeight: "1em", textAlign: "center" },
                      ]}
                    >
                      {m.dataSheetUrl === "pending" ||
                      m.dataSheetUrl === "none" ||
                      m.dataSheetUrl === null ? null : (
                        <div
                          style={[
                            styles.iconsContainer,
                            {
                              display: "table",
                              margin: "0 auto",
                              float: "center",
                            },
                          ]}
                          onClick={async () => {
                            let ablob = m.dataSheet;
                            let notABlob = m.dataSheetUrl;

                            let blob = undefined;
                            if (ablob) {
                              blob = ablob;
                            } else {
                              const myRequest = new Request(notABlob);
                              await fetch(myRequest)
                                .then((response) => response.blob())
                                .then((myBlob) => {
                                  blob = myBlob;
                                });
                            }
                            downloadBlob(blob, m.name + ".sikkerhed.pdf");
                          }}
                          onTouchEnd={() =>
                            m.dataSheet
                              ? this.openPdf(m.dataSheet, true)
                              : this.openPdf(m.dataSheetUrl)
                          }
                        >
                          <i
                            aria-hidden="true"
                            className="fa fa-file-pdf-o"
                            style={styles.icon}
                          />
                          <div style={styles.label}>Vis</div>
                        </div>
                      )}
                    </div>
                    <div
                      className="col-xs-1"
                      style={[
                        styles.td,
                        { lineHeight: "1em", textAlign: "center" },
                      ]}
                    >
                      {m.technicalDataSheetUrl === "pending" ||
                      m.technicalDataSheetUrl === "none" ||
                      m.technicalDataSheetUrl === null ? null : (
                        <div
                          style={[
                            styles.iconsContainer,
                            {
                              display: "table",
                              margin: "0 auto",
                              float: "center",
                            },
                          ]}
                          onClick={async () => {
                            let ablob = m.technicalDataSheet;
                            let notABlob = m.technicalDataSheetUrl;

                            let blob = undefined;
                            if (ablob) {
                              blob = ablob;
                            } else {
                              const myRequest = new Request(notABlob);
                              await fetch(myRequest)
                                .then((response) => response.blob())
                                .then((myBlob) => {
                                  blob = myBlob;
                                });
                            }
                            downloadBlob(blob, m.name + ".teknisk.pdf");
                          }}
                          onTouchEnd={() =>
                            m.dataSheet
                              ? this.openPdf(m.technicalDataSheet, true)
                              : this.openPdf(m.technicalDataSheetUrl)
                          }
                        >
                          <i
                            aria-hidden="true"
                            className="fa fa-file-pdf-o"
                            style={styles.icon}
                          />
                          <div style={styles.label}>Vis</div>
                        </div>
                      )}
                    </div>
                    <div
                      className="col-xs-1"
                      style={[
                        styles.td,
                        { lineHeight: "1em", textAlign: "center" },
                      ]}
                    >
                      {m.chemDataSheetUrl === "pending" ||
                      m.chemDataSheetUrl === "none" ||
                      m.chemDataSheetUrl === undefined ||
                      m.chemDataSheetUrl === null ? null : (
                        <div
                          style={[
                            styles.iconsContainer,
                            {
                              display: "table",
                              margin: "0 auto",
                              float: "center",
                            },
                          ]}
                          onClick={async () => {
                            let ablob = m.chemDataSheet;
                            let notABlob = m.chemDataSheetUrl;

                            let blob = undefined;
                            if (ablob) {
                              blob = ablob;
                            } else {
                              const myRequest = new Request(notABlob);
                              await fetch(myRequest)
                                .then((response) => response.blob())
                                .then((myBlob) => {
                                  blob = myBlob;
                                });
                            }
                            downloadBlob(blob, m.name + ".kemisk.pdf");
                          }}
                          onTouchEnd={() =>
                            m.chemDataSheet
                              ? this.openPdf(m.chemDataSheet, true)
                              : this.openPdf(m.chemDataSheetUrl)
                          }
                        >
                          <i
                            aria-hidden="true"
                            className="fa fa-file-pdf-o"
                            style={styles.icon}
                          />
                          <div style={styles.label}>Vis</div>
                        </div>
                      )}
                    </div>
                    {this.state.role === "Formand" ? null : (
                      <div
                        className="col-xs-1"
                        style={[styles.td, styles.lastInTr]}
                      >
                        {inEditMode.active || inCreateMode.active ? null : (
                          <div>
                            <div
                              className=""
                              style={styles.iconsContainer}
                              onClick={() =>
                                dispatch(
                                  actions.setState("inEditMode", {
                                    active: true,
                                    productId: m.productId,
                                    index: i,
                                  })
                                )
                              }
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                                style={styles.icon}
                              ></i>
                              <div style={styles.label}>Rediger</div>
                            </div>
                            {m.deletable ? (
                              <div
                                className=""
                                style={styles.iconsContainer}
                                onClick={() =>
                                  dispatch(
                                    actions.setState("confirmDeletion", {
                                      active: true,
                                      productId: m.productId,
                                      index: i,
                                    })
                                  )
                                }
                              >
                                <i
                                  className="fa fa-trash-o"
                                  aria-hidden="true"
                                  style={styles.icon}
                                ></i>
                                <div style={styles.label}>Slet</div>
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              }
            })}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

const styles = {
  topContainer: {
    position: "absolute",
    top: "50px",
    height: "50px",
    left: "0",
    width: "100%",
  },
  cell: {
    display: "table-cell",
    padding: 12,
    borderLeft: ".1px solid lightgray",
    borderBottom: ".1px solid lightgray",
  },
  container: {
    position: "absolute",
    paddingTop: "100px",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    "@media (min-width: 1200px)": {
      left: "50%",
      marginLeft: "-585px",
      maxWidth: "1170px",
    },
  },
  createButton: {
    float: "left",
    marginTop: "7px",
    marginLeft: "12px",
    width: "150px",
  },
  fetchingIcon: {
    float: "right",
    fontSize: "26px",
    lineHeight: "50px",
    marginRight: "20px",
  },
  searchField: {
    float: "right",
    marginTop: "7px",
    marginRight: "12px",
    width: "200px",
  },
  icon: {
    fontSize: "20px",
    display: "block",
  },
  iconsContainer: {
    float: "left",
    color: greyScaleColors.greyLight,
    textAlign: "center",
    width: "50%",
    height: "40px",
    paddingTop: "5px",
    position: "relative",
    cursor: "pointer",
  },
  iconsContainerActive: {
    color: semanticColors.info,
  },
  label: {
    fontSize: "8px",
    position: "absolute",
    top: "23px",
    width: "100%",
    fontWeight: "600",
  },
  table: {
    width: "100%",
    height: "100%",
    padding: "50px 12px 12px 12px",
    borderRadius: "2px",
    position: "relative",
    backgroundColor: semanticColors.default,
  },
  thead: {
    position: "absolute",
    left: "0",
    top: "15px",
    width: "100%",
    padding: "0 12px",
  },
  headerRow: {
    backgroundColor: "#FFF",
  },
  tr: {
    margin: "0",
    height: "40px",
    backgroundColor: "#EBEEF0",
  },
  trOdd: {
    backgroundColor: semanticColors.primaryLight,
  },
  lastInTr: {
    borderRight: "none",
    textAlign: "center",
    lineHeight: "1em",
  },
  th: {
    textAlign: "right",
    borderRight: "1px solid " + semanticColors.mainBackground,
    paddingLeft: "5px",
    fontWeight: "600",
    height: "100%",
    lineHeight: "40px",
  },
  td: {
    textAlign: "right",
    borderRight: "1px solid " + semanticColors.mainBackground,
    paddingLeft: "5px",
    height: "100%",
    lineHeight: "40px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  firstTd: {
    textAlign: "left",
  },
};

const selectProps = (state) => {
  return {
    ...state.productReducer,
  };
};

Product.propTypes = {
  confirmDeletion: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    productId: PropTypes.string,
    index: PropTypes.number,
    isSubmitting: PropTypes.bool.isRequired,
  }),
  inCreateMode: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
  }),
  inEditMode: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    productId: PropTypes.string,
    index: PropTypes.number,
    isSubmitting: PropTypes.bool.isRequired,
  }),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      deletable: PropTypes.bool.isRequired,
      productId: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["Materiale", "Materiel"]),
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ),
};

export default connect(selectProps)(Radium(Product));



// WEBPACK FOOTER //
// ./src/App/Product/index.jsx